<template>
  <div class="register-organizer-1">
    <div class="row" :class="storeStepErrors.has('internalError') ? ' has-error' : ''">
      <div class="col-md-12 form-group margin-bottom-30">
        <span class="black-title margin-0">Login Information</span>
        <span class="help-block" v-if="storeStepErrors.has('internalError')">
          <strong>Something went wrong. Please try again later.</strong>
        </span>
      </div>
    </div>

    <form @submit.prevent="onCaptchaExecute" action="#" class="row organizer-form">

      <div class="margin-top-20 margin-bottom-20 col-sm-12">
        <div class="row">
          <div class="form-group col-sm-12">
            <input-label
              type="text"
              css-class="form-control"
              required
              v-model="formData.email"
              placeholder="Email address"
              autocomplete="cc-name"
            />
            <div class="form-group">
              <div class="hint-text">
                A verification email will be sent to this address
              </div>
            </div>

              <div
                class="invalid-feedback-red"
                v-if="storeStepErrors.has('email')"
              >
                {{ storeStepErrors.get("email") }}
              </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-6">
            <input-label
              type="text"
              css-class="form-control"
              required
              v-model="formData.first_name"
              placeholder="First name"
              autocomplete="cc-name"
            />

              <div
                class="invalid-feedback-red"
                v-if="storeStepErrors.has('first_name')"
              >
                {{ storeStepErrors.get("first_name") }}
              </div>
          </div>
          <div class="form-group col-sm-6">
            <input-label
              type="text"
              css-class="form-control"
              required
              v-model="formData.last_name"
              placeholder="Last name"
              autocomplete="cc-name"
            />

              <div
                class="invalid-feedback-red"
                v-if="storeStepErrors.has('last_name')"
              >
                {{ storeStepErrors.get("last_name") }}
              </div>
          </div>
        </div>

        <div class="row margin-top-10">
          <div class="form-group col-sm-12 password-step-1">
            <password-container
              v-model="formData.password"
              autocomplete="nope"
              placeholder="Enter Password"
              label="Password"
              :required="true"
              :withLabel="true"
              role="organizer"
            />

              <div class="invalid-feedback-red"
                v-if="storeStepErrors.has('password')"
              >
                {{ storeStepErrors.get("password") }}
              </div>
          </div>
        </div>

        <div class="row margin-top-10">
          <div class="form-group col-sm-12">
            <password-container
              v-model="formData.password_confirmation"
              autocomplete="nope"
              label="Confirm password"
              placeholder="Confirm password"
              :required="true"
              :show-hint="false"
              :withLabel="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <vue-recaptcha
                class="g-recaptcha"
                ref="recaptcha"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
                size="invisible"
                badge="inline"
                :sitekey="recaptchaSiteKey"
            >
            </vue-recaptcha>

            <div
                class="invalid-feedback-red"
                v-if="storeStepErrors.has('recaptcha_token')"
            >
              {{ storeStepErrors.get("recaptcha_token") }}
            </div>
          </div>
        </div>
      </div>

      <div class="section-footer margin-top-10">
      <div class="form-group col-sm-12">
        <button
            type="submit"
            id="registerByEmailBtn"
            class="btn hh-btn hh-btn-green col-md-12" name="Send email verification">
            
            <p v-if="verified"> Upgrade to Fundraiser </p>
            <p v-else> Send Email Verification </p>
          </button>
      </div>
        <div class="form-group row margin-top-10">
          <div class="col-sm-12 form-agreement-text text-center margin-top-10">
            <p class="">
              By registering your account, you agree to our
              <a href="/terms">Services Agreement</a> and the
              <a href="https://stripe.com/connect-account/legal" target="_blank" rel="noopener"
                >Stripe Connected Account Agreement</a>.
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import InputLabel from "../../../components/form/elements/InputLabel";
import PasswordContainer from "../../../components/form/elements/PasswordContainer";
import Form from '../../../plugins/hh-form.js'
import VueRecaptcha from 'vue-recaptcha'
import constants from "../../../config";

export default {
  name: "Step-1",

  components: {
    InputLabel,
    PasswordContainer,
    'vue-recaptcha': VueRecaptcha,
  },

  props: {
    userData: {
      email: String,
      first_name: String,
      last_name: String,
      verified: Boolean
    },
    config: Object,
    userRoles: Array,
    identities: Array,
    upgradeTo: String,
  },

  data() {
    return {
      loading: true,
      recaptchaSiteKey: null,
      formData: {
          first_name: null,
          last_name: null,
          email: null,
          password: null,
          password_confirmation: null,
          role: "organizer",
          recaptcha_token: null,
          opType: "update",
          step: 1,
        },
        verified: null,
    }
  },

  beforeMount() {
    this.recaptchaSiteKey = constants.RECAPTCHA_INVISIBLE_SITE_KEY
     this.formData = { ...this.formData, ...this.userData }
    this.formData.first_name = this.userData.first_name
    this.formData.last_name = this.userData.last_name
    this.formData.email = this.userData.email
    this.verified = this.userData.verified
    this.loading = false
  },

  mounted() {},

  methods: {
    ...mapActions('upgradeAccount', ['storeStepData']),

    async submit() {
      this.loading = true

      this.storeStepData(this.formData).then(() => {
        this.loading = false
        if (this.storeStepStatus === 'success') {
          this.$emit('formSubmitted')
        }
      })
    },

    cancelAction () {
      this.$router.push({ name:'profile' })
    },

    skipAction () {
      this.$emit('navigateNext')
    },

    onCaptchaVerified: async function (recaptchaToken) {
      this.formData.recaptcha_token = recaptchaToken
      await this.submit()
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    },
    onCaptchaExecute() {
      this.$refs.recaptcha.execute()
    },
  },


    computed: {
      storeStepStatus: {
        get () {
          return this.$store.getters['upgradeAccount/storeStepStatus'](this.formData.step)
        },
      },

      storeStepErrors: {
        get () {
          return this.$store.getters['upgradeAccount/storeStepErrors'](this.formData.step)
        },
      },

      hasErrors () {
        return this.storeStepStatus === 'failed'
      },


      isFormReady () {
        return !this.loading
      },


      unknownError () {
        if (this.hasErrors) {
          if (this.hasErrors && this.storeStepErrors.has('email')) {

            return 'This session has expired. Please login to continue.'

          } else if (!this.storeStepErrors.has('first_name') &&
                     !this.storeStepErrors.has('last_name')) {

            return 'Something went wrong. Please try again later.'
          }
        }

        return null
      },
    },
};
</script>

<style lang="scss" scoped>
.register-organizer-1 {
  hr {
    border: 1px solid whitesmoke;
  }

  .invalid-feedback-red {
    display: block;
    color: rgb(188, 46, 46);

    i {
      margin-right: 10px;
    }
  }

  .organizer-form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .hint-text {
    font-size: 14px;
    color: #b2b2b2;
  }

  .hh-btn-green {
    padding: 20px;
    width: 100%;
  }

  .form-title {
    color: black;
  }
}

  .g-recaptcha::v-deep {
      margin-right: -65px;
  }

  .recaptcha-wrapper {
      margin-left: 15px;
      width: 55%;
  }

  @media screen and (max-width: 991px ) {
    .recaptcha-wrapper {
        width: 80% !important;
        margin-left: 15px;
    }
  }

</style>